import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import HeroCarousel from './HeroCarousel';
import AboutSection from './AboutSection';
import ProductSection from './ProductSection';
import SolutionsSection from './SolutionsSection';
import PricingSection from './PricingSection';
import ResourcesSection from './ResourcesSection';
import ContactSection from './ContactSection';
import LandingFooter from './LandingFooter';
import LoginForm from '../auth/LoginForm';
import DemoMagicSignIn from '../auth/DemoMagicSignIn';
import '../../styles/landing.css';
import backgroundImageLanding from '../../assets/background-image-landing.png';

const LandingPage = () => {
  const location = useLocation();
  const [showLoginModal, setShowLoginModal] = useState(false);

  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const magicToken = query.get('magic')?.trim() || '';
  const tenantOnly = query.get('tenant')?.trim() || '';

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
    
    // Update page title
    document.title = 'ArchonPM — Seismic Project Management | Chrisall Technologies';
  }, []);

  if (magicToken) {
    return <DemoMagicSignIn />;
  }

  if (tenantOnly) {
    return <LoginForm />;
  }

  return (
    <>
      {/* Header outside .landing-page: Safari clips position:fixed when ancestor has overflow-x:hidden */}
      <Header onLoginClick={() => setShowLoginModal(true)} />
      <div className="landing-page" style={{
        backgroundImage: `url(${backgroundImageLanding})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
        position: 'relative'
      }}>
        {/* Background Overlay (70% opacity) */}
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(12, 25, 44, 0.7)',
          zIndex: 0,
          pointerEvents: 'none'
        }}></div>
        
        {/* Content */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          <HeroCarousel onLoginClick={() => setShowLoginModal(true)} />
          <AboutSection />
          <ProductSection />
          <SolutionsSection />
          <PricingSection />
          <ResourcesSection />
          <ContactSection />
          <LandingFooter onLoginClick={() => setShowLoginModal(true)} />
        </div>
      </div>
      
      {/* Login Modal Overlay */}
      {showLoginModal && (
        <LoginForm isModal={true} onClose={() => setShowLoginModal(false)} />
      )}
    </>
  );
};

export default LandingPage;
